export const common = {
  // Nawigacja
  'nav.features': 'Funkcje',
  'nav.howItWorks': 'Jak to działa',
  'nav.pricing': 'Cennik',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'O nas',
  'nav.getStarted': 'Rozpocznij',

  // Sekcja O nas
  'aboutUs.badge': "O nas",
  'aboutUs.title': "Dlaczego istnieje IdeaVerdict",
  'aboutUs.line1': "Każdy może mieć pomysł.",
  'aboutUs.line2': "Niewielu przyzna, że ich pomysł się nie broni.",
  'aboutUs.paragraph1':
    "Większość pomysłów nie upada dlatego, że założycielom brakło odwagi. Upadają, bo nikt nie powiedział im prawdy wystarczająco wcześnie. IdeaVerdict zamyka tę lukę — dajemy Ci brutalną ocenę, której nie usłyszysz od znajomych.",
  'aboutUs.belief1a': "Nie handlujemy hype'em.",
  'aboutUs.belief1b': "Handlujemy sygnałami rynkowymi.",
  'aboutUs.belief2a': "Nie sprzedajemy motywacji.",
  'aboutUs.belief2b': "Sprzedajemy jasną ocenę popytu, konkurencji i wykonalności.",
  'aboutUs.mission1': "Naszym zadaniem nie jest sprawić, by Twój pomysł wyglądał dobrze.",
  'aboutUs.mission2': "Naszym zadaniem jest powiedzieć, czy taki jest.",
  'aboutUs.analysis':
    "IdeaVerdict ocenia pomysły po tym, co ma znaczenie — strukturze rynku, realnym popycie, konkurencji, wymaganym kapitale, czasie do przychodu, skalowalności. Bez emocji. Bez optymizmu. Tylko analiza.",
  'aboutUs.failure1': "Większość firm upada.",
  'aboutUs.failure2': "Nie dlatego, że ludzie za nimi byli niekompetentni —",
  'aboutUs.failure3': "tylko dlatego, że nikt nie zakwestionował ich na czas i wystarczająco mocno.",
  'aboutUs.clarity': "Istniejemy, żeby kwestionować.",
  'aboutUs.value1': "Bezpośrednio.",
  'aboutUs.value2': "Uczciwie.",
  'aboutUs.value3': "Szybko.",
  'aboutUs.confirm': "Jeśli Twój pomysł ma sens, wesprzemy go.",
  'aboutUs.deny': "Jeśli nie ma, powiemy Ci to prosto w twarz.",
  'aboutUs.noApplause': "Bez oklasków.",
  'aboutUs.noSugarcoating': "Bez lukrowania.",
  'aboutUs.noTheater': "Bez teatru.",
  'aboutUs.noHype': "Tylko werdykt.",
  // Sekcja Hero
  'hero.badge': 'Werdykt AI w mniej niż 60 sekund',
  'hero.title1': 'Nie buduj,',
  'hero.title2': 'zanim sprawdzisz.',
  'hero.subtitle': 'IdeaVerdict testuje twój pomysł jak sceptyczny VC.',
  'hero.subtitleLine2': 'Uczciwy werdykt w sekundach — bez hype\'u, bez schlebiania.',
  'hero.cta': 'Otrzymaj werdykt',
  'hero.ctaSecondary': 'Jak to działa',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredytów za zapytanie',
  'hero.stat2Value': 'Od 7',
  'hero.stat2Label': 'Wymiary oceny',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Szczerze i Prywatnie',

  // Sekcja Funkcje
  'features.title1': 'Stworzone dla',
  'features.title2': 'założycieli, którzy',
  'features.title3': 'chcą prawdy',
  'features.bullet1.title': 'Szczery werdykt w kilka sekund',
  'features.bullet1.description':
    'Mocny, Mieszany lub Słaby — z uzasadnieniem. Bez oklasków, bez lukrowania, bez teatru.',
  'features.bullet2.title': 'Oceniane po tym, co naprawdę liczy',
  'features.bullet2.description':
    'Twój pomysł oceniany jest pod kątem realnego popytu, konkurencji, wymaganego kapitału, czasu do przychodów i skalowalności — nie wrażeń.',
  'features.bullet3.title': 'Od werdyktu do realizacji',
  'features.bullet3.description':
    'Tryb Builder zamienia zaakceptowany pomysł w brief dla deweloperów: ścieżki użytkownika, kluczowe funkcje, notatki techniczne.',

  // Jak to działa
  'howItWorks.title': 'Jak to działa',
  'howItWorks.subtitle': 'Cztery kroki do jasności dotyczącej Twojej niszy biznesowej.',
  'howItWorks.step1Title': 'Wybierz plan',
  'howItWorks.step1Desc': 'Starter, Pro lub Builder – w zależności od głębokości analizy.',
  'howItWorks.step2Title': 'Zapytaj AI',
  'howItWorks.step2Desc': 'Zadaj pytania dotyczące niszy. Każde zapytanie kosztuje 30 kredytów.',
  'howItWorks.step3Title': 'Otrzymaj szczery werdykt',
  'howItWorks.step3Desc': 'AI ocenia: Dobry, Przeciętny lub Zły. Bez lukrowania.',
  'howItWorks.step4Title': 'Podejmij decyzję',
  'howItWorks.step4Desc': 'Teraz wiesz, czy warto iść dalej.',

  // Cennik
  'pricing.title': 'Cennik',
  'pricing.subtitle': 'Wybierz plan odpowiedni do głębokości Twojej analizy.',
  'pricing.monthly': 'Miesięczny',
  'pricing.yearly': 'Roczny',
  'pricing.yearlyDiscount': 'Subskrypcja roczna:',
  'pricing.yearlyDiscountValue': '-20% zniżki',
  'pricing.perMonth': 'miesięcznie',
  'pricing.selectPlan': 'Wybierz plan',
  'pricing.mostPopular': 'Najpopularniejszy',
  'pricing.footer':
    'Wszystkie ceny w CHF. Kredyty są odejmowane tylko za udane odpowiedzi AI.',

  // Pricing Features
  'pricing.feature1': 'Generowanie pomysłu na niszę',
  'pricing.feature2': 'Dopracowanie niszy',
  'pricing.feature3': 'Kontrola realności rynkowej',
  'pricing.feature4': 'Ocena konkurencji',
  'pricing.feature5': 'Ocena czasu',
  'pricing.feature6': 'Szczery werdykt',
  'pricing.feature7': 'Prywatne sesje',
  'pricing.feature8': 'Historia i eksport',
  'pricing.feature9': 'Pomysły na nisze',
  'pricing.feature10': 'Analiza trendów',
  'pricing.feature11': 'Sugestie ulepszeń',
  'pricing.feature12': 'Alternatywne nisze',
  'pricing.feature13': 'Szczegółowa analiza rynku',
  'pricing.feature14': 'Priorytetowe wsparcie',
  'pricing.feature15': 'Zaawansowane filtry',
  'pricing.feature16': 'Ulubione sesje',
  'pricing.feature17': 'Alerty analityczne',
  'pricing.feature18': 'Osobisty menedżer ds. sukcesu',

  // Plan Starter
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Dostęp do czatu AI nisz',
  'pricing.starter.credits': '2,500 kredytów miesięcznie',
  'pricing.starter.feature1': 'Generowanie pomysłu na niszę',
  'pricing.starter.feature2': 'Dopracowanie niszy',
  'pricing.starter.feature3': 'Kontrola realności rynkowej',
  'pricing.starter.feature4': 'Ocena konkurencji',
  'pricing.starter.feature5': 'Ocena czasu',
  'pricing.starter.feature6': 'Szczery werdykt',
  'pricing.starter.feature7': 'Prywatne sesje',
  'pricing.starter.feature8': 'Historia i eksport',

  // Plan Pro
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Dostęp do czatu AI nisz',
  'pricing.pro.credits': '5,000 kredytów miesięcznie',
  'pricing.pro.feature1': 'Wszystkie funkcje Starter',
  'pricing.pro.feature2': 'Więcej kredytów do intensywnej analizy',
  'pricing.pro.feature3': 'Sugestie ulepszeń',
  'pricing.pro.feature4': 'Alternatywne nisze',
  'pricing.pro.feature5': 'Szczegółowa analiza rynku',
  'pricing.pro.feature6': 'Priorytetowe wsparcie',
  'pricing.pro.feature7': 'Zaawansowane filtry',
  'pricing.pro.feature8': 'Ulubione sesje',

  // Plan Builder
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Wszystkie funkcje + tryb Builder",
  'pricing.builder.credits': "10 000 kredytów miesięcznie",
  'pricing.builder.feature1': 'Wszystkie funkcje Pro',
  'pricing.builder.feature2': 'Nieograniczone zapytania AI',
  'pricing.builder.feature3': 'Tryb Buildera: Instrukcje dla deweloperów',
  'pricing.builder.feature4': 'Strukturalny przegląd projektu',
  'pricing.builder.feature5': 'Ścieżki użytkownika i kluczowe funkcje',
  'pricing.builder.feature6': 'Notatki techniczne',
  'pricing.builder.feature7': 'Określanie celów spoza zakresu',
  'pricing.builder.feature8': 'Limit uczciwego użytkowania',
  'pricing.builder.limitNote': 'Limit fair use',
  'pricing.monthlyReset': 'Reset miesięczny',

  // Modal
  'pricing.modal.selected': 'wybrany',
  'pricing.modal.comingSoon':
    'Rejestracja i przetwarzanie płatności będą wkrótce dostępne.',
  'pricing.modal.patience':
    'Pracujemy nad zapewnieniem bezpiecznego i płynnego doświadczenia. Prosimy o cierpliwość.',
  'pricing.modal.understood': 'Rozumiem',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Odpowiedzi udzielane uczciwie i krytycznie.',
  'faq.q1': "Co właściwie robi IdeaVerdict?",
  'faq.a1': "Ocenia Twój pomysł biznesowy po tym, co decyduje o wyniku — realnym popycie, konkurencji, wymaganym kapitale, czasie wejścia na rynek i skalowalności.\nJeśli pomysł się broni, pokazujemy, jak go zaostrzyć.\nJeśli nie, też to mówimy.",
  'faq.q2': "Generujecie też pomysły?",
  'faq.a2': "Tak — ale nie losowe sugestie z kapelusza.\nPomysły wyciągamy z realnych luk rynkowych, nie z tego, co modne w tym tygodniu.",
  'faq.q3': "Ulepszacie istniejące modele biznesowe?",
  'faq.a3': "Tak, jeśli jest co ulepszać.\nNie polerujemy zepsutych pomysłów — wzmacniamy te, które mają już fundament.",
  'faq.q4': "Czym się różnicie od innych narzędzi AI?",
  'faq.a4': "Większość narzędzi AI mówi Ci, że Twój pomysł jest świetny.\nMy mówimy, czy faktycznie taki jest.\nRóżnica: realizm zamiast entuzjazmu.",
  'faq.q5': "Czy to gwarantuje sukces?",
  'faq.a5': "Nie.\nPomagamy unikać złych zakładów — ryzyko nie znika, ale wchodzisz w to z otwartymi oczami.",
  'faq.q6': "Dla kogo jest IdeaVerdict?",
  'faq.a6': "Dla założycieli przed startem.\nDla budowniczych przed weekendowym side-projektem.\nDla operatorów przed kolejnym zakładem.\nDla inwestorów przed podpisem.\n\nDla każdego, kto chce jasności przed zobowiązaniem.",
  'faq.q7': "A jeśli chcę tylko walidacji?",
  'faq.a7': "To IdeaVerdict jest złym narzędziem.\nDostarczamy uczciwą ocenę, nie pociechę.",
  'faq.q8': "Jak uczciwa jest naprawdę ta analiza?",
  'faq.a8': "Tak uczciwa, jak pozwalają dane.\nNie łagodzimy słabego werdyktu, żeby oszczędzić uczucia.",
  'faq.q9': "Czy to zastępuje prawdziwe badania rynku?",
  'faq.a9': "Nie.\nTo szybka kontrola strategiczna przed inwestycją — nie 50-stronicowe studium rynku.",
  'faq.q10': "Dlaczego tak bezpośrednio?",
  'faq.a10': "Bo budowanie nie tego, co trzeba, kosztuje miesiące.\nUczciwy werdykt kosztuje minuty.\n\nWybieramy minuty.",
  // Stopka
  'footer.description':
    'IdeaVerdict nie jest tu, żebyś czuł się dobrze. Jest tu, żebyś zdecydował dobrze.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'Asystent AI',
  'footer.howItWorks': 'Jak to działa',
  'footer.pricing': 'Cennik',
  'footer.faq': 'FAQ',
  'footer.legal': 'Informacje prawne',
  'footer.privacy': 'Prywatność',
  'footer.terms': 'Warunki',
  'footer.imprint': 'Impressum',
  'footer.support': 'Wsparcie',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentacja',
  'footer.copyright': '© 2026 IdeaVerdict. Wszelkie prawa zastrzeżone.',

  // Asystent AI
  'aiAssistant.title': 'Asystent AI Nisz',
  'aiAssistant.subtitle': 'Zapytaj o nisze',
  'aiAssistant.welcomeMessage':
    'Cześć! Opisz swój pomysł lub zapytaj mnie o niszę. Dam Ci jasną i szczerą ocenę.',
  'aiAssistant.demoResponse':
    'To jest demo. Aby uzyskać rzeczywiste oceny AI, zarejestruj się i wybierz plan.',
  'aiAssistant.placeholder': 'Opisz swój pomysł...',

  // Nagłówek i panel boczny
  'dashboard.header.title': 'Panel',
  'dashboard.header.aiAssistant': 'Twój Asystent AI',
  'header.logout': 'Wyloguj się',
  'dashboard.sidebar.overview': 'Przegląd',
  'dashboard.sidebar.aiChat': 'Asystent AI',
  'dashboard.sidebar.newAnalysis': 'Asystent AI',
  'dashboard.sidebar.history': 'Historia',
  'dashboard.sidebar.credits': 'Kredyty',
  'dashboard.sidebar.settings': 'Ustawienia',

  // Przegląd panelu
  'dashboard.overview.welcome': 'Witaj ponownie, {{name}}',
  'dashboard.overview.subtitle':
    'Oto szybki przegląd Twojej aktywności',

  // Statystyki panelu
  'dashboard.stats.creditsRemaining': 'Pozostałe kredyty',
  'dashboard.stats.totalAnalyses': 'Liczba analiz',
  'dashboard.stats.goodRatings': 'Pozytywne oceny',
  'dashboard.stats.nextReset': 'Następny reset za',
  'dashboard.stats.days': 'dni',

  // Szybkie akcje
  'dashboard.quickActions.title': 'Szybkie akcje',
  'dashboard.quickActions.checkNewIdea': 'Sprawdź pomysł',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Przeanalizuj istniejący pomysł biznesowy',
  'dashboard.quickActions.generateIdea': 'Wygeneruj pomysł',
  'dashboard.quickActions.generateIdeaDesc':
    'Znajdź nową dochodową niszę',
  'dashboard.quickActions.builderBriefing': 'Instrukcja Buildera',
  'dashboard.quickActions.builderBriefingDesc':
    'Przekształć pomysł w instrukcję dla dewelopera',
  'dashboard.quickActions.premiumOnly': 'Tylko Builder',

  // Nagłówek czatu
  'chat.title': 'Asystent AI Nisz',
  'chat.subtitle':
    'Zadawaj pytania dotyczące nisz. Oceniam krytycznie i uczciwie.',
  'chat.creditsLabel': 'Kredyty',

  // Powitanie na czacie
  'chat.welcomeTitle': 'Witaj w Asystencie AI Nisz',
  'chat.welcomeDesc':
    'Opisz swój pomysł lub zapytaj o niszę. Ocenię go uczciwie: Dobry, Przeciętny lub Zły.',
  'chat.aiWelcome':
    'Cześć! Opisz swój pomysł lub zapytaj mnie o niszę. Dam Ci jasną i szczerą ocenę.',

  // Sugestie czatu
  'chat.suggestion1': 'Chcę stworzyć narzędzie SaaS dla freelancerów do zarządzania fakturami. Czy to dobra nisza?',
  'chat.suggestion2': 'Znajdź mi biznes online z małą konkurencją, który mogę zacząć za $500 bez umiejętności programowania.',
  'chat.suggestion3': 'Oceń to: aplikacja do planowania posiłków z AI dla zapracowanych rodziców z ograniczeniami dietetycznymi.',
  'chat.suggestion4': 'Chcę sprzedawać cyfrowe szablony na Etsy dla małych przedsiębiorców. Przeanalizuj tę niszę uczciwie.',

  // Akcje czatu
  'chat.newConversation': 'Nowa rozmowa',
  'chat.today': 'Dzisiaj',
  'chat.yesterday': 'Wczoraj',
  'chat.thisWeek': 'W tym tygodniu',
  'chat.thisMonth': 'W tym miesiącu',
  'chat.older': 'Starsze',
  'chat.messages': 'wiadomości',
  'chat.renameConversation': 'Zmień nazwę',
  'chat.deleteConversation': 'Usuń',
  'chat.cancel': 'Anuluj',
  'chat.rename': 'Zmień nazwę',
  'chat.delete': 'Usuń',
  'chat.favorite': 'Dodaj do ulubionych',
  'chat.unfavorite': 'Usuń z ulubionych',
  'chat.searchSessions': 'Szukaj rozmów...',
  'chat.noResults': 'Nie znaleziono wyników',
  'chat.noSessions': 'Brak rozmów',
  'chat.enterNewName': 'Wprowadź nową nazwę...',
  'chat.deleteConfirmMessage':
    'Czy na pewno chcesz usunąć tę rozmowę? Tej operacji nie można cofnąć.',

  // Pole wprowadzania i błędy czatu
  'chat.inputPlaceholder': 'Wpisz pytanie… (kosztuje 30 kredytów)',
  'chat.send': 'Wyślij',
  'chat.voice': 'Mów',
  'chat.listeningPlaceholder': 'Słucham... Mów teraz.',
  'chat.stopListening': 'Zatrzymaj słuchanie',
  'chat.recording': 'Nagrywanie...',
  'chat.speechNotSupported': 'Twoja przeglądarka nie obsługuje rozpoznawania mowy.',
  'chat.microphonePermissionDenied': 'Odmowa dostępu do mikrofonu. Zezwól na dostęp w ustawieniach przeglądarki.',
  'chat.errorNotEnoughCredits':
    'Brak wystarczającej liczby kredytów. Ulepsz swój plan lub poczekaj na następny reset.',
  'chat.errorAiFailed': 'Odpowiedź AI nie powiodła się. Żadne kredyty nie zostały odjęte.',
  'chat.errorRateLimit': 'Zbyt wiele zapytań. Proszę czekać chwilę.',

  // Oceny
  'rating.good': 'Dobry',
  'rating.medium': 'Przeciętny',
  'rating.bad': 'Zły',

  // Strona logowania
  'auth.branding.headline1': 'Nie każdy pomysł jest dobry.',
  'auth.branding.headline2': 'Mówimy Ci to szczerze.',
  'auth.branding.subtitle':
    'Sztuczna inteligencja decyzyjna dla nisz biznesowych. Jasna. Krytyczna. Bez lukrowania.',
  'auth.benefits.privacy.title': '100% Prywatne',
  'auth.benefits.privacy.desc':
    'Twoje pomysły pozostają całkowicie prywatne i bezpieczne.',
  'auth.benefits.honest.title': 'Szczera AI',
  'auth.benefits.honest.desc':
    'Bez lukrowania – po prostu jasna, krytyczna informacja zwrotna.',
  'auth.benefits.fast.title': 'Szybkie wyniki',
  'auth.benefits.fast.desc': 'Uzyskaj jasność co do swojej niszy w ciągu kilku minut.',
  'auth.trust.users': 'Aktywni użytkownicy',
  'auth.trust.ideas': 'Przeanalizowane pomysły',
  'auth.trust.rating': 'Ocena użytkowników',
  'auth.login.title': 'Logowanie',
  'auth.login.headline': 'Witaj ponownie',
  'auth.login.subtitle': 'Zaloguj się, aby kontynuować swoją podróż.',
  'auth.login.forgotPassword': 'Nie pamiętasz hasła?',
  'auth.login.submit': 'Zaloguj się',
  'auth.login.noAccount': 'Nie masz jeszcze konta?',
  'auth.login.signUp': 'Zarejestruj się',
  'auth.register.title': 'Rejestracja',
  'auth.register.headline': 'Utwórz swoje konto',
  'auth.register.subtitle':
    'Zacznij analizować swoje pomysły biznesowe już dziś.',
  'auth.register.submit': 'Utwórz konto',
  'auth.register.hasAccount': 'Masz już konto?',
  'auth.register.signIn': 'Zaloguj się',
  'auth.fields.name': 'Imię i nazwisko',
  'auth.fields.email': 'Adres e-mail',
  'auth.fields.password': 'Hasło',
  'auth.fields.confirmPassword': 'Potwierdź hasło',
  'auth.fields.selectPlan': 'Wybierz swój plan',
  'auth.fields.testCode': 'Zaloguj się i przetestuj za darmo',
  'auth.placeholders.name': 'Wprowadź swoje imię',
  'auth.placeholders.email': 'Wprowadź swój e-mail',
  'auth.placeholders.password': 'Wprowadź swoje hasło',
  'auth.placeholders.confirmPassword': 'Potwierdź swoje hasło',
  'auth.placeholders.testCode': 'Wprowadź kod testowy',
  'auth.terms.accept': 'Akceptuję',
  'auth.terms.terms': 'Warunki korzystania',
  'auth.privacy.accept': 'Akceptuję',
  'auth.privacy.policy': 'Politykę prywatności',
  'auth.errors.nameRequired': 'Imię jest wymagane',
  'auth.errors.emailRequired': 'E-mail jest wymagany',
  'auth.errors.emailInvalid': 'Wprowadź poprawny adres e-mail',
  'auth.errors.passwordRequired': 'Hasło jest wymagane',
  'auth.errors.passwordLength': 'Hasło musi mieć co najmniej 8 znaków',
  'auth.errors.passwordMismatch': 'Hasła nie są zgodne',
  'auth.errors.invalidCode': 'Nieprawidłowy lub wygasły kod',
  'auth.errors.registrationCodeOnly': 'Ten kod jest przeznaczony tylko do rejestracji',
  'auth.errors.verificationFailed': 'Błąd weryfikacji kodu. Spróbuj ponownie.',
  'auth.loading': 'Proszę czekać...',
  'auth.or': 'lub kontynuuj przez',
  'auth.social.google': 'Kontynuuj przez Google',
  'auth.social.apple': 'Kontynuuj przez Apple',
  'auth.actions.verify': 'Zweryfikuj',
  'auth.testCode.activated': 'Kod testowy aktywowany!',
  'auth.testCode.days': 'dni',
  'auth.testCode.months': 'miesięcy',
  'auth.testCode.freeAccess': 'darmowy dostęp',
  'auth.testCode.credits': 'kredytów',

  // Weryfikacja e-mail
  'auth.verification.title': 'Zweryfikuj e-mail',
  'auth.verification.headline': 'Sprawdź swoją skrzynkę odbiorczą',
  'auth.verification.subtitle': 'Wysłaliśmy kod weryfikacyjny na:',
  'auth.verification.codeLabel': 'Kod weryfikacyjny',
  'auth.verification.codePlaceholder': 'Wprowadź 6-cyfrowy kod',
  'auth.verification.submit': 'Zweryfikuj e-mail',
  'auth.verification.resend': 'Wyślij kod ponownie',
  'auth.verification.resendIn': 'Wyślij ponownie za',
  'auth.verification.seconds': 'sekund',
  'auth.verification.success': 'E-mail zweryfikowany pomyślnie!',
  'auth.verification.error': 'Nieprawidłowy kod. Spróbuj ponownie.',
  'auth.verification.expired': 'Kod wygasł. Poproś o nowy.',
  'auth.verification.sent': 'Nowy kod wysłany!',
  'auth.verification.checkSpam':
    'Nie otrzymałeś? Sprawdź folder spam.',

  // Nie pamiętam hasła
  'auth.forgot.title': 'Nie pamiętam hasła',
  'auth.forgot.headline': 'Zresetuj swoje hasło',
  'auth.forgot.subtitle':
    'Wprowadź swój adres e-mail, a wyślemy Ci link do resetowania hasła.',
  'auth.forgot.submit': 'Wyślij link resetujący',
  'auth.forgot.backToLogin': 'Powrót do logowania',
  'auth.forgot.success': 'E-mail wysłany!',
  'auth.forgot.successMessage':
    'Wysłaliśmy Ci e-mail z instrukcjami resetowania hasła.',
  'auth.forgot.checkInbox': 'Sprawdź swoją skrzynkę odbiorczą',

  // Resetowanie hasła
  'auth.reset.title': 'Nowe hasło',
  'auth.reset.headline': 'Ustaw nowe hasło',
  'auth.reset.subtitle': 'Wprowadź swoje nowe hasło.',
  'auth.reset.newPassword': 'Nowe hasło',
  'auth.reset.confirmNewPassword': 'Potwierdź nowe hasło',
  'auth.reset.submit': 'Zmień hasło',
  'auth.reset.success': 'Hasło zmienione pomyślnie!',
  'auth.reset.successMessage':
    'Możesz teraz zalogować się za pomocą nowego hasła.',
  'auth.reset.loginNow': 'Zaloguj się teraz',

  // Strony prawne
  'legal.backToAuth': 'Powrót do logowania',
  'legal.allRightsReserved': 'Wszelkie prawa zastrzeżone.',

  // Strona Warunki
  'legal.terms.title': 'Warunki korzystania',
  'legal.terms.lastUpdated': 'Ostatnia aktualizacja',
  'legal.terms.section1.title': '1. Zakres',
  'legal.terms.section1.content':
    'Niniejsze Warunki korzystania mają zastosowanie do wszystkich umów między NicheFinder (zwanym dalej „Dostawcą”) a użytkownikiem (zwanym dalej „Klientem”) dotyczących korzystania z platformy do analizy nisz opartej na sztucznej inteligencji.',
  'legal.terms.section2.title': '2. Opis usługi',
  'legal.terms.section2.content':
    'Dostawca oferuje platformę opartą na sztucznej inteligencji, która analizuje i ocenia pomysły biznesowe i nisze. Usługi obejmują:',
  'legal.terms.section2.item1': 'Analizę pomysłów biznesowych opartą na AI',
  'legal.terms.section2.item2': 'Ocenę potencjału rynkowego i konkurencji',
  'legal.terms.section2.item3': 'Generowanie sugestii nisz',
  'legal.terms.section2.item4': 'Tworzenie instrukcji dla deweloperów (pakiet Builder)',
  'legal.terms.section3.title': '3. Zawarcie umowy i rejestracja',
  'legal.terms.section3.content':
    'Umowa zostaje zawarta poprzez rejestrację na platformie i wybór pakietu. Klient potwierdza:',
  'legal.terms.section3.item1': 'Pełnoletność i pełną zdolność do czynności prawnych',
  'legal.terms.section3.item2': 'Podanie prawdziwych informacji podczas rejestracji',
  'legal.terms.section3.item3': 'Bezpieczne przechowywanie danych dostępowych',
  'legal.terms.section4.title': '4. Kredyty i rozliczenia',
  'legal.terms.section4.content':
    'Korzystanie z funkcji AI opiera się na systemie kredytowym. Każde zapytanie AI kosztuje 30 kredytów. Kredyty są odejmowane tylko po udanej odpowiedzi. Niewykorzystane kredyty wygasają z końcem okresu rozliczeniowego i nie podlegają zwrotowi.',
  'legal.terms.section5.title': '5. Wyłączenie odpowiedzialności',
  'legal.terms.section5.content':
    'Oceny AI służą wyłącznie jako pomoc w podejmowaniu decyzji i nie gwarantują sukcesu biznesowego. Dostawca nie ponosi odpowiedzialności za decyzje podjęte na podstawie analiz AI. Odpowiedzialność z tytułu umyślnego działania i rażącego zaniedbania pozostaje nienaruszona.',
  'legal.terms.section6.title': '6. Ochrona danych i poufność',
  'legal.terms.section6.content':
    'Wszystkie przesłane pomysły biznesowe są traktowane poufnie i nie są udostępniane stronom trzecim. Przetwarzanie danych osobowych odbywa się zgodnie z naszą Polityką prywatności i obowiązującymi przepisami o ochronie danych.',
  'legal.terms.section7.title': '7. Wypowiedzenie',
  'legal.terms.section7.content':
    'Klient może wypowiedzieć swoją subskrypcję w dowolnym momencie na koniec bieżącego okresu rozliczeniowego. W przypadku naruszenia niniejszych Warunków Dostawca zastrzega sobie prawo do zablokowania dostępu do platformy.',
  'legal.terms.section8.title': '8. Postanowienia końcowe',
  'legal.terms.section8.content':
    'Ma zastosowanie prawo szwajcarskie. Miejscem jurysdykcji jest Zurych, Szwajcaria. W przypadku gdy poszczególne postanowienia niniejszych Warunków są nieważne, ważność pozostałych postanowień pozostaje nienaruszona.',
  'legal.terms.contact.title': 'Pytania dotyczące Warunków?',
  'legal.terms.contact.content':
    'Jeśli masz pytania dotyczące niniejszych Warunków korzystania, skontaktuj się z nami pod adresem:',

  // Strona Polityka prywatności
  'legal.privacy.title': 'Polityka prywatności',
  'legal.privacy.section1.title': '1. Administrator danych',
  'legal.privacy.section1.content':
    'Administratorem danych tej strony internetowej jest NicheFinder, Zurych, Szwajcaria. Traktujemy ochronę Twoich danych osobowych bardzo poważnie i przetwarzamy Twoje dane osobowe poufnie oraz zgodnie z ustawowymi przepisami o ochronie danych.',
  'legal.privacy.section2.title': '2. Gromadzone dane',
  'legal.privacy.section2.content':
    'Gromadzimy i przetwarzamy następujące dane osobowe:',
  'legal.privacy.section2.item1':
    'Dane rejestracyjne: Imię, nazwisko, adres e-mail, hasło (szyfrowane)',
  'legal.privacy.section2.item2':
    'Dane użytkowania: Adres IP, typ przeglądarki, czasy dostępu',
  'legal.privacy.section2.item3':
    'Pomysły biznesowe i zapytania dotyczące nisz (przechowywane anonimowo)',
  'legal.privacy.section2.item4':
    'Informacje o płatnościach (za pośrednictwem bezpiecznych zewnętrznych dostawców)',
  'legal.privacy.section3.title': '3. Cel przetwarzania danych',
  'legal.privacy.section3.content':
    'Twoje dane są wykorzystywane do następujących celów:',
  'legal.privacy.section3.item1':
    'Świadczenie i ulepszanie naszych usług AI',
  'legal.privacy.section3.item2':
    'Zarządzanie kontem i uwierzytelnianie',
  'legal.privacy.section3.item3':
    'Rozliczenia i przetwarzanie płatności',
  'legal.privacy.section4.title': '4. Bezpieczeństwo danych',
  'legal.privacy.section4.content':
    'Wdrażamy techniczne i organizacyjne środki bezpieczeństwa, aby chronić Twoje dane przed manipulacją, utratą, zniszczeniem lub nieuprawnionym dostępem. Wszystkie transmisje danych są szyfrowane za pomocą SSL/TLS.',
  'legal.privacy.section5.title': '5. Poufność Twoich pomysłów biznesowych',
  'legal.privacy.section5.content':
    'Twoje przesłane pomysły biznesowe i zapytania dotyczące nisz są traktowane jako ściśle poufne. Nie są udostępniane stronom trzecim, nie są wykorzystywane do celów szkoleniowych i mogą zostać całkowicie usunięte na żądanie. Twoje pomysły należą do Ciebie.',
  'legal.privacy.section6.title': '6. Twoje prawa',
  'legal.privacy.section6.content':
    'Masz następujące prawa dotyczące swoich danych osobowych:',
  'legal.privacy.section6.item1': 'Prawo dostępu do przechowywanych danych',
  'legal.privacy.section6.item2': 'Prawo do sprostowania nieprawidłowych danych',
  'legal.privacy.section6.item3': 'Prawo do usunięcia swoich danych',
  'legal.privacy.section6.item4': 'Prawo do przenoszenia danych',
  'legal.privacy.section7.title': '7. Pliki cookie',
  'legal.privacy.section7.content':
    'Nasza strona internetowa używa wyłącznie technicznie niezbędnych plików cookie do uwierzytelniania i zarządzania sesjami. Nie używamy plików cookie śledzących ani zewnętrznych narzędzi analitycznych bez Twojej wyraźnej zgody.',
  'legal.privacy.section8.title': '8. Zmiany niniejszej Polityki prywatności',
  'legal.privacy.section8.content':
    'Zastrzegamy sobie prawo do dostosowania niniejszej polityki prywatności w celu spełnienia zmienionych wymogów prawnych lub gdy zmiany w usłudze tego wymagają. Aktualna wersja jest zawsze dostępna na tej stronie.',
  'legal.privacy.contact.title': 'Pytania dotyczące prywatności?',
  'legal.privacy.contact.content':
    'Jeśli masz pytania dotyczące przetwarzania Twoich danych osobowych, skontaktuj się z nami pod adresem:',

  'auth.passwordStrength.label': 'Siła hasła',
  'auth.passwordStrength.weak': 'Słabe',
  'auth.passwordStrength.medium': 'Średnie',
  'auth.passwordStrength.strong': 'Silne',
  'auth.passwordStrength.veryStrong': 'Bardzo silne',
  'auth.passwordStrength.minLength': 'Min. 8 znaków',
  'auth.passwordStrength.uppercase': 'Wielka litera',
  'auth.passwordStrength.number': 'Cyfra',
  'auth.passwordStrength.special': 'Znak specjalny',

  trial: {
    subtitle: 'Bezpłatny okres próbny',
    upgrade: 'Ulepsz teraz',
    creditsRemaining: 'pozostałych kredytów',
    inputHint: 'Wersja próbna - Historia rozmów niedostępna',
    banner: {
      title: 'Aktywny 7-dniowy okres próbny',
      remaining: 'pozostało {{days}} dni',
      credits: 'dostępnych kredytów',
      upgradeNow: 'Ulepsz teraz',
    },
    welcome: {
      title: 'Witaj w bezpłatnym okresie próbnym!',
      desc: 'Testuj naszego asystenta AI przez 7 dni za darmo ze 100 kredytami. Zadawaj pytania i odkrywaj możliwości!',
    },
    info: {
      title: 'Ograniczenia okresu próbnego',
      credits: '100 kredytów na 7 dni',
      noHistory: 'Brak historii rozmów',
      noSettings: 'Ograniczone funkcje',
      upgrade: 'Ulepsz, aby uzyskać pełne funkcje',
    },
  },

  // ─── Strona Ustawienia ────────────────────────────────────────────────────────────
  'settings.title': 'Ustawienia',
  'settings.subtitle': 'Zarządzaj swoim kontem i preferencjami',
  'settings.backToOverview': 'Powrót do przeglądu',
  'settings.subscriptionLink': 'Subskrypcja i rozliczenia',
  'settings.saved': 'Zmiany zapisane pomyślnie',
  'settings.changesSaved': 'Zmiany zapisane',
  'settings.saveChanges': 'Zapisz zmiany',
  'settings.dataExported': 'Dane wyeksportowane pomyślnie',

  // Zakładki
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Preferencje',
  'settings.tabs.notifications': 'Powiadomienia',
  'settings.tabs.account': 'Konto i plan',

  // Profil
  'settings.profile.changePhoto': 'Zmień zdjęcie',
  'settings.profile.photoHint': 'JPG, PNG lub GIF (maks. 2MB)',
  'settings.profile.uploading': 'Przesyłanie...',
  'settings.profile.photoUpdated': 'Zdjęcie profilowe zaktualizowane!',
  'settings.profile.name': 'Imię',
  'settings.profile.email': 'E-mail',
  'settings.profile.phone': 'Telefon',
  'settings.profile.changePassword': 'Zmień hasło',
  'settings.profile.currentPassword': 'Bieżące hasło',
  'settings.profile.newPassword': 'Nowe hasło',
  'settings.profile.confirmPassword': 'Potwierdź hasło',

  // Preferencje
  'settings.preferences.language': 'Język',
  'settings.preferences.chooseLanguage': 'Wybierz język',
  'settings.preferences.timezone': 'Strefa czasowa',
  'settings.preferences.currency': 'Waluta',

  // Powiadomienia
  'settings.notifications.emailTitle': 'Powiadomienia e-mail',
  'settings.notifications.email.analysis': 'Analiza zakończona',
  'settings.notifications.email.analysisDesc': 'Otrzymuj e-mail, gdy analiza jest gotowa',
  'settings.notifications.email.credits': 'Aktualizacje kredytów',
  'settings.notifications.email.creditsDesc': 'Powiadomienia o kredytach i resetach',
  'settings.notifications.email.billing': 'Faktury i płatności',
  'settings.notifications.email.billingDesc': 'Powiadomienia o fakturach i zmianach planu',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Wskazówki, aktualizacje i nowe funkcje',
  'settings.notifications.pushTitle': 'Powiadomienia push',
  'settings.notifications.push.analysis': 'Analiza zakończona',
  'settings.notifications.push.analysisDesc': 'Powiadomienie przeglądarkowe, gdy analiza jest gotowa',
  'settings.notifications.push.credits': 'Ostrzeżenia o kredytach',
  'settings.notifications.push.creditsDesc': 'Ostrzeżenie, gdy saldo kredytów jest niskie',

  // Konto
  'settings.account.currentSubscription': 'Bieżąca subskrypcja',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Cena',
  'settings.account.nextBilling': 'Następne rozliczenie',
  'settings.account.manageSubscription': 'Zarządzaj subskrypcją i płatnościami',
  'settings.account.dataPrivacy': 'Dane i prywatność',
  'settings.account.exportData': 'Eksportuj dane',
  'settings.account.deleteAccount': 'Usuń konto',

  // Modal usuwania
  'settings.deleteModal.title': 'Usunąć konto?',
  'settings.deleteModal.subtitle': 'Wszystkie dane zostaną trwale usunięte.',
  'settings.deleteModal.warning1': 'Wszystkie analizy i dane zostaną usunięte',
  'settings.deleteModal.warning2': 'Aktywna subskrypcja zostanie natychmiast anulowana',
  'settings.deleteModal.warning3': 'Zwrot pieniędzy niemożliwy',
  'settings.deleteModal.confirmLabel': 'Wpisz "{{word}}", aby potwierdzić *',
  'settings.deleteModal.cancel': 'Anuluj',
  'settings.deleteModal.confirm': 'Usuń konto',

  // ─── Subskrypcja i rozliczenia ─────────────────────────────────────────────
  'sub.backToOverview': 'Powrót do przeglądu',
  'sub.settings': 'Ustawienia',
  'sub.title': 'Subskrypcja i rozliczenia',
  'sub.subtitle': 'Zarządzaj swoją subskrypcją, metodami płatności i fakturami',
  'sub.tab.overview': 'Przegląd',
  'sub.tab.payment': 'Metody płatności',
  'sub.tab.billing': 'Adres do faktury',
  'sub.tab.history': 'Historia płatności',
  'sub.memberSince': 'Użytkownik od',
  'sub.perMonth': 'miesięcznie',
  'sub.baseCHF': '(CHF {{amount}} podstawowa)',
  'sub.nextBilling': 'Następne rozliczenie',
  'sub.creditsUsed': 'Wykorzystane kredyty',
  'sub.paymentMethod': 'Metoda płatności',
  'sub.creditUsage': 'Wykorzystanie kredytów',
  'sub.changePlan': 'Zmień plan',
  'sub.reactivate': 'Reaktywuj',
  'sub.cancelSub': 'Anuluj subskrypcję',
  'sub.manageCards': 'Zarządzaj kartami',
  'sub.downloadInvoices': 'Pobierz faktury',
  'sub.invoicesAvailable': '{{count}} faktur dostępnych jako PDF',
  'sub.accountSettings': 'Ustawienia konta',
  'sub.profileNotifications': 'Profil, powiadomienia i więcej',
  // Informacje o cenach w EUR
  'sub.eurInfo': 'Ceny podane w',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Kurs:',
  'sub.currentRate': 'Aktualny kurs',
  // Metody płatności
  'sub.savedCards': 'Zapisane karty',
  'sub.newCard': 'Nowa karta',
  'sub.default': 'Domyślna',
  'sub.setDefault': 'Ustaw jako domyślną',
  'sub.validUntil': 'Ważna do',
  'sub.noCards': 'Brak zapisanych kart',
  'sub.addFirstCard': 'Dodaj pierwszą kartę',
  'sub.securePayments': 'Bezpieczne płatności',
  'sub.securePaymentsDesc': 'Wszystkie dane płatności są przesyłane szyfrowane i przechowywane bezpiecznie u naszego dostawcy płatności. Nie przechowujemy pełnych numerów kart.',
  // Adres do faktury
  'sub.billingAddress': 'Adres do faktury',
  'sub.edit': 'Edytuj',
  'sub.name': 'Imię i nazwisko',
  'sub.streetAddress': 'Ulica i numer',
  'sub.zip': 'Kod pocztowy',
  'sub.city': 'Miasto',
  'sub.country': 'Kraj',
  'sub.address': 'Adres',
  'sub.save': 'Zapisz',
  'sub.cancel': 'Anuluj',
  'sub.country.switzerland': 'Szwajcaria',
  'sub.country.germany': 'Niemcy',
  'sub.country.austria': 'Austria',
  'sub.country.netherlands': 'Holandia',
  'sub.country.belgium': 'Belgia',
  // Historia płatności
  'sub.paymentHistory': 'Historia płatności',
  'sub.allInvoicesPDF': 'Pobierz wszystkie faktury jako PDF z logo',
  'sub.downloadAll': 'Pobierz wszystkie',
  'sub.eurInvoiceNote': 'Faktury są zawsze wystawiane w CHF. Wyświetlane kwoty w EUR służą wyłącznie do celów informacyjnych.',
  'sub.date': 'Data',
  'sub.description': 'Opis',
  'sub.net': 'Netto',
  'sub.vat': 'VAT',
  'sub.total': 'Razem',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'faktur',
  'sub.totalAmount': 'Całkowita kwota',
  // Modal zmiany planu
  'sub.changePlanTitle': 'Zmień plan',
  'sub.current': 'Bieżący',
  'sub.month': '/miesiąc',
  'sub.showLess': 'Pokaż mniej',
  'sub.showMore': '+{{count}} więcej',
  'sub.switchPlan': 'Zmień plan',
  'sub.eurPriceNote': 'Ceny podane w EUR ({{note}}). Rozliczenie w CHF.',
  // Modal anulowania
  'sub.cancelTitle': 'Na pewno anulować subskrypcję?',
  'sub.cancelIrreversible': 'Tej operacji nie można cofnąć.',
  'sub.cancelWarning1': 'Wszystkie pozostałe kredyty wygasną',
  'sub.cancelWarning2': 'Przejście na plan darmowy',
  'sub.cancelWarning3': 'Utrata wszystkich funkcji premium',
  'sub.pauseInstead': 'Alternatywa: Wstrzymać subskrypcję?',
  'sub.pauseDesc': 'Wstrzymaj subskrypcję zamiast anulować i zachowaj swoje dane.',
  'sub.preferPause': 'Wolę wstrzymać',
  'sub.cancelReason': 'Powód anulowania',
  'sub.selectReason': 'Wybierz...',
  'sub.reason.tooExpensive': 'Zbyt drogie',
  'sub.reason.notUsing': 'Nie używam wystarczająco często',
  'sub.reason.missingFeatures': 'Brakujące funkcje',
  'sub.reason.foundAlternative': 'Znalazłem alternatywę',
  'sub.reason.other': 'Inny',
  'sub.confirmType': 'Potwierdzenie: Wpisz "ANULUJ" *',
  'sub.cancelNow': 'Anuluj teraz',
  // Modal dodawania karty
  'sub.addCardTitle': 'Dodaj nową kartę',
  'sub.cardHolder': 'Posiadacz karty *',
  'sub.cardNumber': 'Numer karty *',
  'sub.expiryDate': 'Data ważności *',
  'sub.addCard': 'Dodaj kartę',
  // Modal zmiany karty
  'sub.choosePayment': 'Wybierz metodę płatności',
  'sub.active': 'Aktywna',
  'sub.close': 'Zamknij',
  // Komunikaty Toast
  'sub.toast.cancelled': 'Twoja subskrypcja została anulowana z końcem okresu rozliczeniowego.',
  'sub.toast.reactivated': 'Twoja subskrypcja została pomyślnie reaktywowana!',
  'sub.toast.planChanged': 'Plan pomyślnie zmieniony na {{plan}}!',
  'sub.toast.defaultChanged': 'Domyślna metoda płatności zmieniona.',
  'sub.toast.cannotDeleteDefault': 'Nie można usunąć domyślnej karty.',
  'sub.toast.cardRemoved': 'Karta została usunięta.',
  'sub.toast.fillAll': 'Wypełnij wszystkie pola.',
  'sub.toast.cardAdded': 'Nowa karta dodana pomyślnie!',
  'sub.toast.billingSaved': 'Adres do faktury zapisany.',
  'sub.toast.invoiceDownloaded': 'Faktura {{id}} pobrana!',
  'sub.toast.pdfError': 'Błąd podczas tworzenia PDF.',
  // Interfejs czatu
  'sub.notEnoughCredits': 'Brak wystarczających kredytów',
  'sub.needCredits': 'Potrzebujesz co najmniej {{count}} kredytów na pytanie.',
  'sub.creditsLow': 'Kredyty na wyczerpaniu',
  'sub.questionsLeft': '{{count}} pytań możliwych.',
  'sub.plan': 'Plan',
  'sub.base': 'podstawa',
  'sub.unlimited': 'Nielimitowany',
  'sub.status.active': 'Aktywny',
  'sub.status.cancelled': 'Anulowany',
  'sub.status.paused': 'Wstrzymany',
  'sub.invoice': 'FAKTURA',
  'sub.from': 'OD',
  'sub.to': 'DO',
  'sub.vatId': 'NIP',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Data faktury',
  'sub.invoiceNumber': 'Numer faktury',
  'sub.paymentStatus': 'Status płatności',
  'sub.creditCard': 'Karta kredytowa',
  'sub.quantity': 'ILOŚĆ',
  'sub.price': 'CENA',
  'sub.amount': 'KWOTA',
  'sub.subtotal': 'Suma częściowa',
  'sub.bank': 'Bank',
  'sub.card': 'Karta',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Jan Kowalski',

  // ─── Panel administracyjny ─────────────────────────────────────────────────────────────
  'admin.title': 'Panel administratora',
  'admin.subtitle': 'Centrum sterowania',
  'admin.superAdmin': 'Super administrator',
  'admin.logout': 'Wyloguj się',
  'admin.tabs.users': 'Zarządzanie użytkownikami',
  'admin.tabs.downgrades': 'Obniżenia',
  'admin.tabs.tips': 'Wskazówka dnia',
  'admin.tabs.coupons': 'Kody rabatowe',
  'admin.tabs.website': 'Edytor strony',
  'admin.tabs.ai': 'Ustawienia AI',
  'admin.tabs.transactions': 'Log transakcji',
  'admin.tabs.stats': 'Statystyki',
  'admin.users.searchPlaceholder': 'Szukaj użytkowników (e-mail lub nazwa)...',
  'admin.users.manageSubscription': 'Zarządzaj subskrypcją',
  'admin.users.grantFree': 'Przyznaj darmowe konto',
  'admin.users.blockUser': 'Zablokuj użytkownika',
  'admin.users.cancellationPlaceholder': 'Dlaczego subskrypcja jest anulowana?',
  'admin.users.selectPlan': 'Wybierz plan',
  'admin.users.subChanged': 'Subskrypcja {{name}} zmieniona na {{plan}}',
  'admin.users.noReasonGiven': 'Nie podano powodu',
  'admin.users.subCancelled': 'Subskrypcja {{name}} anulowana (ważna do {{date}})',
  'admin.users.paused': 'Wstrzymany',
  'admin.users.subPaused': 'Subskrypcja {{name}} została wstrzymana',
  'admin.users.subReactivated': 'Subskrypcja {{name}} została reaktywowana',
  'admin.users.freeAccount': 'Darmowe konto',
  'admin.users.blocked': 'Zablokowany',
  'admin.users.cancelledExpiring': 'Anulowana (wygasa)',
  'admin.users.cancelledOn': 'Anulowana:',
  'admin.users.endsOn': 'Kończy się:',
  'admin.users.daysRemaining': 'pozostałych dni',
  'admin.users.expired': '(Wygasła)',
  'admin.users.total': 'Razem:',
  'admin.users.usersLabel': 'użytkowników',
  'admin.users.free': 'darmowych',
  'admin.users.block': 'Zablokuj',
  'admin.users.unblock': 'Odblokuj',
  'admin.users.unblockUser': 'Odblokuj użytkownika',
  'admin.users.selectAction': 'Wybierz akcję',
  'admin.users.cancelSub': 'Anuluj subskrypcję',
  'admin.users.cancelSubDesc': 'Anulowanie z końcem miesiąca',
  'admin.users.pauseSub': 'Wstrzymaj subskrypcję',
  'admin.users.pauseSubDesc': 'Tymczasowe wstrzymanie',
  'admin.users.changePlan': 'Zmień plan',
  'admin.users.changePlanDesc': 'Przełącz na inny plan',
  'admin.users.reactivateSub': 'Reaktywuj subskrypcję',
  'admin.users.reactivateDesc': 'Cofnij anulowanie',
  'admin.users.alreadyCancelled': 'Subskrypcja już anulowana',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Powód anulowania (opcjonalny)',
  'admin.users.cancelInfo1': 'Subskrypcja zakończy się',
  'admin.users.cancelInfo2': '(z końcem miesiąca). Do tego czasu użytkownik ma pełny dostęp. Brak zwrotu pieniędzy.',
  'admin.users.newPlan': 'Nowy plan',
  'admin.users.warning': 'Ostrzeżenie',
  'admin.users.blockDesc': 'Użytkownik zostanie natychmiast wylogowany i nie będzie mógł się ponownie zalogować. Wszystkie aktywne sesje zostaną zakończone.',
  'admin.users.confirmUnblock': 'Potwierdź odblokowanie',
  'admin.users.unblockDesc': 'Użytkownik może się ponownie zalogować i korzystać ze wszystkich funkcji.',
  'admin.users.afterBlock': 'Po zablokowaniu:',
  'admin.users.afterUnblock': 'Po odblokowaniu:',
  'admin.users.noAccountAccess': 'Brak dostępu do konta',
  'admin.users.noNewAnalyses': 'Brak możliwości nowych analiz',
  'admin.users.creditsStored': 'Kredyty i historia pozostają zapisane',
  'admin.users.accessRestored': 'Dostęp do konta przywrócony',
  'admin.users.allFeaturesAvail': 'Wszystkie funkcje ponownie dostępne',
  'admin.users.creditsPreserved': 'Kredyty i historia zachowane',
  'admin.users.downgrade': 'Obniżenie planu',
  'admin.users.grantFreeBtn': 'Przyznaj darmowe',
  'admin.users.durationMonths': 'Czas trwania (miesiące)',
  'admin.users.months': 'miesiąc(e)',
  'admin.users.freePlan': 'darmowy',
  'admin.users.freeSummary': 'otrzymuje',
  'admin.users.withCredits': 'z',
  'admin.users.credits': 'Kredytami',
  'admin.users.subInfo': 'Informacje o subskrypcji',
  'admin.users.currentPlan': 'Bieżący plan',
  'admin.users.joined': 'Dołączył',
  'admin.users.totalSpent': 'Łącznie wydane',
  'admin.users.paymentMethod': 'Metoda płatności',
  'admin.users.validThrough': 'Ważna do',
  'admin.users.billingAddress': 'Adres do faktury',
  'admin.users.transactionHistory': 'Historia transakcji',
  'admin.users.cancellationDate': 'Data anulowania',
  'admin.users.validUntil': 'Ważna do (koniec miesiąca)',
  'admin.users.cancellationReason': 'Powód anulowania',
  'admin.users.noReason': 'Nie podano powodu',
  'admin.users.timeRemaining': 'Pozostały czas',
  'admin.users.daysUntilDeactivation': 'dni do dezaktywacji',
  'admin.table.user': 'Użytkownik',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Status subskrypcji',
  'admin.table.cancellation': 'Anulowanie',
  'admin.table.payment': 'Metoda płatności',
  'admin.table.spending': 'Wydatki',
  'admin.table.actions': 'Akcje',
  'admin.actions.viewDetails': 'Zobacz szczegóły',
  'admin.actions.manageSubscription': 'Zarządzaj subskrypcją',
  'admin.actions.grantFree': 'Przyznaj darmowy dostęp',
  'admin.actions.block': 'Zablokuj użytkownika',
  'admin.actions.unblock': 'Odblokuj użytkownika',
  'admin.actions.cancel': 'Anuluj',
  'admin.actions.save': 'Zapisz',
  'admin.actions.delete': 'Usuń',
  'admin.actions.confirm': 'Potwierdź',
  'admin.actions.done': 'Gotowe',
  'admin.actions.edit': 'Edytuj',
  'admin.actions.close': 'Zamknij',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Wszystkie',
  'admin.subscription.active': 'Aktywny',
  'admin.subscription.cancelled': 'Anulowany',
  'admin.subscription.paused': 'Wstrzymany',
  'admin.subscription.unknown': 'Nieznany',
  'admin.status.active': 'Aktywny',
  'admin.status.inactive': 'Nieaktywny',
  'admin.status.pending': 'Oczekujący',
  'admin.status.approved': 'Zatwierdzony',
  'admin.status.rejected': 'Odrzucony',
  'admin.coupons.title': 'Zarządzanie kuponami',
  'admin.coupons.subtitle': 'Twórz kody rabatowe i zarządzaj nimi',
  'admin.coupons.newCoupon': 'Nowy kupon',
  'admin.coupons.registrationCoupons': 'Kupony rejestracyjne',
  'admin.coupons.trialCoupons': 'Kupony dostępu próbnego',
  'admin.coupons.type': 'Typ',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Wartość',
  'admin.coupons.usage': 'Wykorzystanie',
  'admin.coupons.validUntil': 'Ważny do',
  'admin.coupons.created': 'Utworzony',
  'admin.coupons.actions': 'Akcje',
  'admin.coupons.copyCode': 'Kopiuj kod',
  'admin.coupons.allPlans': 'Wszystkie plany',
  'admin.coupons.discount': 'Zniżka',
  'admin.coupons.days': 'dni',
  'admin.coupons.months': 'miesięcy',
  'admin.coupons.free': 'darmowy',
  'admin.coupons.unlimited': 'Nieograniczony',
  'admin.coupons.createRegistration': 'Utwórz kupon rejestracyjny',
  'admin.coupons.createTrial': 'Utwórz kupon dostępu próbnego',
  'admin.coupons.couponCode': 'Kod kuponu',
  'admin.coupons.codePlaceholder': 'np. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generuj nowy kod',
  'admin.coupons.alertFillRequired': 'Wypełnij wszystkie wymagane pola',
  'admin.coupons.alertSelectExpiry': 'Wybierz datę ważności lub włącz "Nieograniczona ważność"',
  'admin.coupons.alertCreateError': 'Błąd podczas tworzenia kuponu',
  'admin.coupons.confirmDelete': 'Czy na pewno chcesz usunąć ten kupon?',
  'admin.coupons.discountPercent': 'Zniżka (%)',
  'admin.coupons.bonusCredits': 'Bonusowe kredyty',
  'admin.coupons.freeDuration': 'Darmowy okres',
  'admin.coupons.maxUses': 'Maks. użyć',
  'admin.coupons.expiryDate': 'Data ważności',
  'admin.coupons.unlimitedValidity': 'Nieograniczona ważność',
  'admin.coupons.unlimitedUses': 'Nieograniczone użycia',
  'admin.coupons.trialCredits': 'Kredyty próbne',
  'admin.coupons.trialDuration': 'Czas trwania próbnego',
  'admin.coupons.typePlaceholder': 'np. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Czas trwania',
  'admin.stats.totalUsers': 'Liczba użytkowników',
  'admin.stats.monthlyRevenue': 'Miesięczny przychód',
  'admin.stats.activeSubscriptions': 'Aktywne subskrypcje',
  'admin.stats.average': 'Średnia',
  'admin.stats.revenuePerUser': 'Przychód na użytkownika',
  'admin.stats.grossRevenue': 'Przychód brutto',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Przychód netto',
  'admin.stats.churnRate': 'Wskaźnik rezygnacji',
  'admin.stats.planDistribution': 'Dystrybucja planów',
  'admin.stats.users': 'użytkowników',
  'admin.stats.revenueByPlan': 'Przychód według planu',
  'admin.stats.recentActivity': 'Ostatnia aktywność',
  'admin.stats.activity1': 'Thomas Weber ulepszył do Builder',
  'admin.stats.activity2': 'Nowy użytkownik zarejestrował się',
  'admin.stats.activity3': 'Anna Schmidt ulepszyła do Pro',
  'admin.stats.hoursAgo2': '2 godziny temu',
  'admin.stats.hoursAgo5': '5 godzin temu',
  'admin.stats.dayAgo1': '1 dzień temu',
  'admin.stats.couponStats': 'Statystyki kuponów',
  'admin.stats.totalRedemptions': 'Łączna liczba realizacji',
  'admin.stats.activeCoupons': 'Aktywne kupony',
  'admin.stats.registrationRedemptions': 'Realizacje rejestracyjne',
  'admin.stats.trialRedemptions': 'Realizacje próbne',
  'admin.stats.couponDistribution': 'Dystrybucja kuponów',
  'admin.stats.registrationCoupons': 'Kupony rejestracyjne',
  'admin.stats.trialCoupons': 'Kupony próbne',
  'admin.stats.expiredInactive': 'Wygasłe/Nieaktywne',
  'admin.stats.topCoupons': 'Najlepsze kupony według realizacji',
  'admin.stats.redemptions': 'realizacji',
  'admin.stats.noCouponsRedeemed': 'Nie zrealizowano jeszcze żadnych kuponów',
  'admin.downgrade.pending': 'oczekujące',
  'admin.downgrade.refunds': 'Zwroty',
  'admin.downgrade.sectionRequests': 'Żądania',
  'admin.downgrade.sectionStats': 'Statystyki',
  'admin.downgrade.sectionRules': 'Reguły',
  'admin.downgrade.pendingRequests': 'Oczekujące żądania',
  'admin.downgrade.approvedRequests': 'Zatwierdzone żądania',
  'admin.downgrade.rejectedRequests': 'Odrzucone żądania',
  'admin.downgrade.activeRules': 'Aktywne reguły',
  'admin.downgrade.autoRules': 'Automatyczne reguły obniżania',
  'admin.downgrade.autoRulesDesc': 'Twórz reguły, które automatycznie wyzwalają obniżenia na podstawie zachowania użytkownika',
  'admin.downgrade.newRule': 'Nowa reguła',
  'admin.downgrade.totalRules': 'Liczba reguł',
  'admin.downgrade.triggeredActions': 'Wyzwolone akcje',
  'admin.downgrade.conditionsAnd': 'Warunki (połączone AND)',
  'admin.downgrade.action': 'Akcja',
  'admin.downgrade.successTitle': 'Obniżenie udane!',
  'admin.downgrade.successDesc': 'Użytkownik został pomyślnie obniżony, a zwrot został przetworzony.',
  'admin.downgrade.closing': 'Zamykanie...',
  'admin.downgrade.title': 'Obniżenie użytkownika',
  'admin.downgrade.currentPlan': 'Bieżący plan',
  'admin.downgrade.spending': 'Wydatki',
  'admin.downgrade.availablePlans': 'Dostępne plany do obniżenia',
  'admin.downgrade.perMonth': 'miesięcznie',
  'admin.downgrade.refundCalc': 'Obliczenie zwrotu',
  'admin.downgrade.currentPlanLabel': 'Bieżący plan',
  'admin.downgrade.newPlan': 'Nowy plan',
  'admin.downgrade.remainingDays': 'Pozostałe dni',
  'admin.downgrade.daysOf': '15 z 30 dni',
  'admin.downgrade.proRataRefund': 'Zwrot proporcjonalny',
  'admin.downgrade.importantNote': 'Ważna uwaga',
  'admin.downgrade.warningDesc': 'Obniżenie zostanie wykonane natychmiast. Użytkownik straci dostęp do funkcji premium, a nadmiarowe kredyty zostaną usunięte.',
  'admin.downgrade.processing': 'Przetwarzanie...',
  'admin.downgrade.execute': 'Wykonaj obniżenie',
  'admin.downgrade.notification': 'Powiadomienie',
  'admin.downgrade.noNotification': 'Brak powiadomienia',
  'admin.downgrade.daysPeriod': 'dni okresu karencji',
  'admin.downgrade.created': 'Utworzono:',
  'admin.downgrade.triggered': 'wyzwolono',
  'admin.downgrade.noRules': 'Nie utworzono jeszcze żadnych reguł',
  'admin.downgrade.createFirstRule': 'Utwórz pierwszą regułę',
  'admin.downgrade.editRule': 'Edytuj regułę',
  'admin.downgrade.createRule': 'Utwórz nową regułę',
  'admin.downgrade.ruleName': 'Nazwa reguły',
  'admin.downgrade.description': 'Opis',
  'admin.downgrade.allConditions': 'Warunki (wszystkie muszą być spełnione)',
  'admin.downgrade.addCondition': 'Dodaj warunek',
  'admin.downgrade.type': 'Typ',
  'admin.downgrade.value': 'Wartość',
  'admin.downgrade.fromPlan': 'Z planu',
  'admin.downgrade.toPlan': 'Do planu',
  'admin.condition.inactivity': 'Brak aktywności',
  'admin.condition.creditUsage': 'Wykorzystanie kredytów',
  'admin.condition.loginFrequency': 'Częstotliwość logowania',
  'admin.condition.featureUsage': 'Wykorzystanie funkcji',
  'admin.condition.supportTickets': 'Zgłoszenia wsparcia',
  'admin.operator.lessThan': 'mniej niż',
  'admin.operator.greaterThan': 'więcej niż',
  'admin.operator.equals': 'dokładnie',
  'admin.operator.between': 'pomiędzy',
  'admin.unit.days': 'dni',
  'admin.unit.perMonth': 'miesięcznie',
  'admin.unit.count': 'liczba',
  'admin.transactions.all': 'Wszystkie transakcje',
  'admin.transactions.allCards': 'Wszystkie karty',
  'admin.transactions.notFound': 'Nie znaleziono transakcji',
  'admin.transactions.totalLabel': 'Razem',
  'admin.transactions.transactions': 'transakcji',
  'admin.tips.title': 'Wskazówka dnia',
  'admin.tips.subtitle': 'Twórz wskazówki wyświetlane wszystkim użytkownikom i zarządzaj nimi',
  'admin.tips.active': 'Aktywny',
  'admin.tips.currentlyShown': 'Ta wskazówka jest obecnie wyświetlana wszystkim użytkownikom',
  'admin.tips.createNew': 'Utwórz nową wskazówkę',
  'admin.tips.generating': 'Generowanie...',
  'admin.tips.generateAI': 'Generuj wskazówkę AI',
  'admin.tips.titleLabel': 'Tytuł',
  'admin.tips.titlePlaceholder': 'np. Wskazówka dnia',
  'admin.tips.category': 'Kategoria',
  'admin.tips.categoryTip': 'Wskazówka',
  'admin.tips.categoryFeature': 'Nowa funkcja',
  'admin.tips.categoryProductivity': 'Produktywność',
  'admin.tips.categoryUpdate': 'Aktualizacja',
  'admin.tips.content': 'Treść',
  'admin.tips.contentPlaceholder': 'Wpisz tutaj swoją wskazówkę dla użytkowników...',
  'admin.tips.addTip': 'Dodaj wskazówkę',
  'admin.tips.allTips': 'Wszystkie wskazówki',
  'admin.tips.noTips': 'Nie utworzono jeszcze żadnych wskazówek',
  'admin.tips.noTipsHint': 'Kliknij „Generuj wskazówkę AI”, aby rozpocząć',
  'admin.noData': 'Brak dostępnych danych',
  'admin.range.7d': '7 dni',
  'admin.range.30d': '30 dni',
  'admin.range.90d': '90 dni',
  'admin.range.1y': '1 rok',
  'admin.actions.saveSettings': 'Zapisz ustawienia',
  'admin.actions.create': 'Utwórz',
  'admin.downgrade.sectionReports': 'Raporty',
  'admin.downgrade.settings': 'Ustawienia obniżania',
  'admin.downgrade.autoApprove': 'Automatyczne zatwierdzanie',
  'admin.downgrade.autoApproveDesc': 'Automatycznie zatwierdzaj żądania obniżenia',
  'admin.downgrade.refundPolicy': 'Polityka zwrotów',
  'admin.downgrade.prorata': 'Zwrot proporcjonalny',
  'admin.downgrade.prorataDesc': 'Proporcjonalny zwrot na podstawie pozostałych dni',
  'admin.downgrade.fullRefund': 'Pełny zwrot',
  'admin.downgrade.fullRefundDesc': 'Całkowity zwrot różnicy ceny',
  'admin.downgrade.noRefund': 'Brak zwrotu',
  'admin.downgrade.noRefundDesc': 'Obniżenie bez zwrotu pieniędzy',
  'admin.downgrade.daysRemaining15': '(z 15 pozostałymi dniami)',
  'admin.downgrade.requestsTitle': 'Żądania obniżenia',
  'admin.downgrade.approvalRate': 'Wskaźnik zatwierdzeń',
  'admin.downgrade.mostCommonTransition': 'Najczęstsze przejście',
  'admin.downgrade.mostCommonReason': 'Najczęstszy powód',
  'admin.downgrade.avgProcessingTime': 'Średni czas przetwarzania',
  'admin.downgrade.avgTimeDesc': 'Średni czas do decyzji',
  'admin.downgrade.totalRefunds': 'Łączne zwroty',
  'admin.downgrade.pendingRefunds': 'Oczekujące zwroty',
  'admin.downgrade.summary': 'Podsumowanie',
  'admin.downgrade.total': 'Razem',
  'admin.downgrade.csvDesc': 'Dla Excel, Arkusze Google',
  'admin.downgrade.downloadCSV': 'Pobierz jako CSV',
  'admin.downgrade.jsonDesc': 'Dla programistów, API',
  'admin.downgrade.downloadJSON': 'Pobierz jako JSON',
  'admin.downgrade.exportInfo': 'Eksport zawiera',
  'admin.downgrade.entries': 'wpisów z wybranego okresu',
  'admin.downgrade.topReasons': 'Najczęstsze powody obniżenia',
  'admin.downgrade.refundHistory': 'Historia zwrotów',
  'admin.downgrade.noRefunds': 'Brak zwrotów',
  'admin.downgrade.statistics': 'Statystyki obniżeń',
  'admin.downgrade.requests': 'Żądania',
  'admin.downgrade.monthlyTrend': 'Trend miesięczny',
  'admin.downgrade.planTransitions': 'Przejścia między planami',
  'admin.downgrade.trend': 'Trend (vs. poprzedni miesiąc)',
  'admin.downgrade.trendDesc': 'Mniej obniżeń = lepiej',
  'admin.coupons.allPlansUniversal': 'Wszystkie plany (uniwersalny)',
  'admin.coupons.onlyStarter': 'Tylko Starter',
  'admin.coupons.onlyPro': 'Tylko Pro',
  'admin.coupons.onlyBuilder': 'Tylko Builder',
  'admin.coupons.allPlansHint': 'Wybierz „Wszystkie plany”, aby uzyskać uniwersalny kupon',
  'admin.coupons.discountOptional': 'Zniżka % (opcjonalnie)',
  'admin.coupons.discountPlaceholder': 'np. 50 dla 50% zniżki',
  'admin.coupons.bonusCreditsOptional': 'Bonusowe kredyty (opcjonalnie)',
  'admin.coupons.bonusCreditsPlaceholder': 'np. 500',
  'admin.coupons.freeDurationOptional': 'Darmowy okres (opcjonalnie)',
  'admin.coupons.durationPlaceholder': 'np. 30',
  'admin.coupons.freeDurationHint': 'np. 30 dni darmowego użytkowania',
  'admin.coupons.noLimit': 'Brak limitu użyć',
  'admin.coupons.noExpiry': 'Brak daty ważności',
  'admin.coupons.creditsPlaceholder': 'np. 100',
  'admin.coupons.creditsHint': 'Liczba kredytów dla dostępu próbnego',
  'admin.coupons.trialDurationHint': 'Jak długo ważny jest dostęp próbny',
  'admin.coupons.autoCalculated': 'Automatycznie obliczane na podstawie czasu trwania próbnego',
  'admin.websiteEditor.title': 'Edytor strony',
  'admin.websiteEditor.subtitle': 'Edytuj wszystkie sekcje strony głównej',
  'admin.websiteEditor.openPreview': 'Otwórz podgląd',
  'admin.websiteEditor.group.structure': 'Struktura strony',
  'admin.websiteEditor.group.design': 'Projekt i układ',
  'admin.websiteEditor.group.settings': 'Ustawienia',
  'admin.websiteEditor.tab.navbar': 'Nawigacja',
  'admin.websiteEditor.tab.howitworks': 'Jak to działa',
  'admin.websiteEditor.tab.about': 'O nas',
  'admin.websiteEditor.tab.pricing': 'Cennik',
  'admin.websiteEditor.tab.sections': 'Sekcje',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Porozmawiaj z nami',
  'admin.websiteEditor.tab.invoice': 'Faktury',
  'admin.websiteEditor.tab.legal': 'Informacje prawne',
  'admin.websiteEditor.tab.seo': 'Podstawowe SEO',
  'admin.websiteEditor.tab.advancedseo': 'Zaawansowane SEO',
  'admin.websiteEditor.tab.versions': 'Wersje',
  'admin.hero.title': 'Edytuj sekcję Hero',
  'admin.hero.subtitle': 'Teksty, przyciski i statystyki strony głównej',
  'admin.hero.reset': 'Resetuj',
  'admin.hero.save': 'Zapisz',
  'admin.hero.savedMsg': 'Dane hero zapisane!',
  'admin.hero.badge': 'Tekst odznaki',
  'admin.hero.headings': 'Nagłówki',
  'admin.hero.line1White': 'Linia 1 (biała)',
  'admin.hero.line2Gold': 'Linia 2 (złota)',
  'admin.hero.subtitleSection': 'Podtytuł',
  'admin.hero.line1': 'Linia 1',
  'admin.hero.line2': 'Linia 2',
  'admin.hero.buttons': 'Przyciski',
  'admin.hero.primaryBtn': 'Przycisk główny (złoty)',
  'admin.hero.secondaryBtn': 'Przycisk pomocniczy (obramowanie)',
  'admin.hero.stats': 'Statystyki',
  'admin.hero.statN': 'Statystyka {{n}}',
  'admin.hero.value': 'Wartość',
  'admin.hero.label': 'Etykieta',
  'admin.hero.previewNote': 'Zmiany będą widoczne na stronie głównej po zapisaniu. Odśwież stronę, aby zobaczyć podgląd.',

  // Historia pomysłów
  'history.title': 'Historia pomysłów',
  'history.countLabel': '{{count}} analiz',
  'history.recentLabel': 'Twoje ostatnie analizy',
  'history.exportAll': 'Eksportuj wszystkie',
  'history.metrics.marketSize': 'Wielkość rynku',
  'history.metrics.competition': 'Konkurencja',
  'history.metrics.startingCapital': 'Kapitał początkowy',
  'history.metrics.timeToMarket': 'Czas wprowadzenia',
  'history.metrics.profitPotential': 'Potencjał zysku',
  'history.metrics.scalability': 'Skalowalność',
  'history.summary.title': 'Podsumowanie',
  'history.download': 'Pobierz',
  'history.downloadJSON': 'Zapisz jako JSON',
  'history.downloadTXT': 'Zapisz jako TXT',
  'history.downloadPDF': 'Zapisz jako PDF',
  'history.fullAnalysis': 'Pełna analiza',
  'history.searchPlaceholder': 'Szukaj po tytule lub tagach...',
  'history.filterAll': 'Wszystkie oceny',
  'history.loading': 'Ładowanie analiz...',
  'history.noResults': 'Nie znaleziono wyników',
  'history.empty': 'Brak analiz',
  'history.emptyHint': 'Rozpocznij analizę w Asystencie AI',
  'history.delete': 'Usuń',
  'history.cancel': 'Anuluj',
  'history.deleteModalTitle': 'Usunąć analizę?',
  'history.deleteModalDesc': '„{{title}}” zostanie trwale usunięta.',
  'history.errorLoading': 'Błąd podczas ładowania analiz',
  'history.deleteSuccess': 'Analiza pomyślnie usunięta',
  'history.deleteError': 'Błąd podczas usuwania analizy',
  'history.jsonExported': 'JSON wyeksportowany',
  'history.txtExported': 'TXT wyeksportowany',
  'history.allExported': '{{count}} pomysłów wyeksportowanych',
  'history.analysisHeader': 'ANALIZA POMYSŁU',
  'history.titleLabel': 'Tytuł',
  'history.ratingLabel': 'Ocena',
  'history.dateLabel': 'Data',
  'history.creditsLabel': 'Kredyty',
  'history.analysisSection': 'Analiza',

  // Przegląd
  'overview.title': 'Przegląd',
  'overview.last24h': 'Ostatnie 24 godziny',
  'overview.analysesToday': 'Analizy dzisiaj',
  'overview.totalAnalyses': 'Liczba analiz',
  'overview.successRate': 'Wskaźnik sukcesu',
  'overview.topRatings': 'Najwyższe oceny',
  'overview.recentActivity': 'Ostatnia aktywność',
  'overview.viewAll': 'Zobacz wszystkie',
  'overview.quickAccess': 'Szybki dostęp',
  'overview.quick.newAnalysis': 'Rozpocznij nową analizę',
  'overview.quick.newAnalysisDesc': 'Rozpocznij nową analizę niszy opartą na AI',
  'overview.quick.myAnalyses': 'Moje analizy',
  'overview.quick.myAnalysesDesc': 'Zobacz wszystkie poprzednie analizy',
  'overview.quick.buyCredits': 'Kup kredyty',
  'overview.quick.buyCreditsDesc': 'Więcej kredytów do więcej analiz',
  'overview.quick.settings': 'Ustawienia',
  'overview.quick.settingsDesc': 'Dostosuj profil i preferencje',
  'overview.unlimitedCredits': 'Dostępne nielimitowane kredyty',
  'overview.creditsAvailable': 'dostępnych kredytów',
  'overview.upgradePlan': 'Ulepsz plan',
  'overview.buyCredits': 'Kup kredyty',
  'overview.creditUsage': 'Wykorzystanie kredytów w tym miesiącu',
  'overview.available': 'dostępne',

  // --- Nowe klucze administratora ---
  'admin.transactions.upgrades': 'Ulepszenia',
  'admin.transactions.downgrades': 'Obniżenia',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',
  
  'admin.users.grantFreeSuccess': '{{name}} ma teraz {{months}} miesiąc(e) darmowego planu {{plan}}',
  'admin.users.blockSuccess': '{{name}} został zablokowany',
  'admin.users.unblockSuccess': '{{name}} został odblokowany',
  'admin.users.removeFreeSuccess': 'Status darmowy {{name}} został usunięty',
  
  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Darmowy',
  
  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Odkryj nową funkcję',
  'admin.tips.productivityBoost': 'Zwiększenie produktywności',
  'admin.tips.importantUpdate': 'Ważna aktualizacja',
  'admin.tips.tipOfDay': 'Wskazówka dnia',

  'admin.actions.activate': 'Aktywuj',
  'admin.actions.deactivate': 'Dezaktywuj',
  'admin.websiteEditor.tab.features': 'Funkcje',
  'admin.websiteEditor.tab.testimonials': 'Opinie',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Stopka',
  'admin.websiteEditor.tab.design': 'Projekt',
  'admin.websiteEditor.tab.customcode': 'Niestandardowy kod',
  'admin.websiteEditor.tab.socials': 'Media społecznościowe',
  'admin.websiteEditor.tab.importexport': 'Import/Eksport',

  // --- Edytor ustawień AI ---
  'admin.ai.title': 'Ustawienia asystenta AI',
  'admin.ai.subtitle': 'Skonfiguruj zachowanie, styl i głębokość analizy',
  'admin.ai.smartWeightingActive': 'Inteligentne ważenie aktywne',
  'admin.ai.smartWeightingDesc': 'AI automatycznie łączy wszystkie perspektywy z inteligentnym ważeniem. W przypadku wielu presetów, pierwszy jest ważony bardziej (główny preset). Możesz również dostosować wagę ręcznie.',
  'admin.ai.modelTitle': 'Model AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'Wybierz silnik AI dla wszystkich analiz użytkowników',
  'admin.ai.activeModel': 'Aktywny model:',
  'admin.ai.activeModelDesc': 'Wszyscy użytkownicy otrzymują odpowiedzi z tego modelu.',
  'admin.ai.recommendations': 'Rekomendacje dla optymalnych wyników',
  'admin.ai.new': 'NOWE',
  'admin.ai.recommendationsDesc': 'Sprawdzone kombinacje presetów dla najlepszej jakości analizy',
  'admin.ai.recommendationsInfo': 'Te kombinacje zostały przetestowane i dają najlepsze wyniki. Kliknij rekomendację, aby zastosować ją bezpośrednio.',
  'admin.ai.active': 'AKTYWNY',
  'admin.ai.apply': 'Zastosuj',
  'admin.ai.avoid': 'Unikaj',
  'admin.ai.excellentQuality': 'Doskonała jakość',
  'admin.ai.goodQuality': 'Dobra jakość',
  'admin.ai.poorQuality': 'Rozwodniona jakość - niezalecane',
  'admin.ai.proTips': 'Porady Pro',
  'admin.ai.tip1Title': '2 presetów są optymalne:',
  'admin.ai.tip1Desc': 'Wyraźna perspektywa bez rozwodnienia',
  'admin.ai.tip2Title': 'Główny preset ma znaczenie:',
  'admin.ai.tip2Desc': 'Pierwszy preset ma największy wpływ',
  'admin.ai.tip3Title': 'Unikaj przeciwieństw:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = sprzeczne',
  'admin.ai.tip4Title': 'Maksymalnie 3 presetów:',
  'admin.ai.tip4Desc': 'Przy 4+ presetach wynik staje się zbyt ogólny',
  'admin.ai.warningManyPresets': 'Ostrzeżenie: Wiele presetów',
  'admin.ai.warningManyPresetsDesc': 'Masz wybranych {{count}} presetów. Może to rozwodnić wynik.',
  'admin.ai.warningRecommend': 'Zalecane: Maksymalnie 2-3 presetów',
  'admin.ai.forOptimalResults': 'dla optymalnych wyników.',
  'admin.ai.presets': 'Presety',
  'admin.ai.multiSelect': '(możliwy wielokrotny wybór)',
  'admin.ai.presetsDesc': 'Wybierz jeden lub więcej presetów. Pierwszy preset jest głównym presetem z najwyższą wagą.',
  'admin.ai.primaryPreset': 'Główny preset',
  'admin.ai.weightControl': 'Kontrola wag',
  'admin.ai.weightControlDesc': 'Dostosuj, jak silnie każdy preset wpływa na analizę',
  'admin.ai.manual': 'Ręcznie',
  'admin.ai.automatic': 'Automatycznie',
  'admin.ai.autoWeightingActive': 'Automatyczne ważenie aktywne:',
  'admin.ai.autoWeightingDesc': 'Waga jest automatycznie optymalizowana na podstawie liczby presetów.',
  'admin.ai.primary': 'GŁÓWNY',
  'admin.ai.totalWeight': 'Razem',
  'admin.ai.shouldBe100': 'powinno wynosić 100%',
  'admin.ai.normalize': 'Normalizuj',
  'admin.ai.combinedSettings': 'Połączone ustawienia',
  'admin.ai.presetsCount': 'presetów',
  'admin.ai.strictness': 'Surowość',
  'admin.ai.realism': 'Realizm',
  'admin.ai.creativity': 'Kreatywność',
  'admin.ai.detailLevel': 'Poziom szczegółowości',
  'admin.ai.customInstructions': 'Niestandardowe instrukcje',
  'admin.ai.customInstructionsDesc': 'Dodatkowe instrukcje, które są łączone z presetami',
  'admin.ai.customInstructionsPlaceholder': 'np. „Skoncentruj się na rynku DACH”, „Zawsze używaj konkretnych liczb”, „Porównaj z istniejącymi konkurentami”, „Zawsze odpowiadaj z przykładami”...',
  'admin.ai.customInstructionsHint': 'Te instrukcje są automatycznie łączone z wybranymi presetami.',
  'admin.ai.manualFinetuning': 'Ręczne dostrajanie',
  'admin.ai.manualFinetuningHint': '(opcjonalne, zastępuje wartości presetów)',
  'admin.ai.manualFinetuningDesc': 'Ręcznie dostosuj połączone wartości, jeśli chcesz coś dopracować.',
  'admin.ai.tone': 'Ton',
  'admin.ai.mild': 'Łagodny',
  'admin.ai.strict': 'Surowe',
  'admin.ai.creative': 'Kreatywne',
  'admin.ai.realistic': 'Realistyczne',
  'admin.ai.conservative': 'Konserwatywne',
  'admin.ai.compact': 'Zwięzłe',
  'admin.ai.detailed': 'Szczegółowe',
  'admin.ai.responseLength': 'Długość odpowiedzi',
  'admin.ai.short': 'Krótka i zwięzła',
  'admin.ai.medium': 'Średnia',
  'admin.ai.long': 'Szczegółowa',
  'admin.ai.focusAreas': 'Obszary skupienia analizy',
  'admin.ai.autoRating': 'Automatyczna ocena',
  'admin.ai.autoRatingDesc': 'Każda analiza automatycznie otrzymuje ocenę (Dobry/Średni/Zły)',
  'admin.ai.showSources': 'Pokaż źródła',
  'admin.ai.showSourcesDesc': 'Odniesienia do źródeł danych i danych rynkowych w odpowiedziach',
  'admin.ai.hidePreview': 'Ukryj podgląd',
  'admin.ai.showPreview': 'Pokaż podgląd',
  'admin.ai.aiBehavior': 'Zachowanie AI',
  'admin.ai.length': 'Długość',
  'admin.ai.liveExample': 'Przykład na żywo',
  'admin.ai.testSettings': 'Przetestuj swoje ustawienia',
  'admin.ai.selectExampleQuestion': 'Wybierz przykładowe pytanie:',
  'admin.ai.userAsks': 'Użytkownik pyta:',
  'admin.ai.generating': 'AI generuje odpowiedź...',
  'admin.ai.generateExample': 'Generuj przykładową odpowiedź',
  'admin.ai.aiResponds': 'Asystent AI odpowiada:',
  'admin.ai.generateHint': 'Kliknij „Generuj przykładową odpowiedź”, aby zobaczyć, jak AI odpowiada z Twoimi ustawieniami.',
  'admin.ai.reset': 'Resetuj',
  'admin.ai.saved': 'Zapisano!',
  'admin.ai.saveSettings': 'Zapisz ustawienia',

  // --- Nagłówki tabel ---
  'admin.coupons.code': 'Kod',
  'admin.coupons.credits': 'Kredyty',

  // --- Opisy modeli AI ---
  'admin.ai.model.standardDesc': 'Zrównoważona analiza z wysoką jakością. Najlepszy wybór do większości ocen nisz i walidacji pomysłów.',
  'admin.ai.model.preciseAnalyses': 'Precyzyjne analizy',
  'admin.ai.model.bestBalance': 'Najlepsza równowaga',
  'admin.ai.model.recommended': 'Zalecany',
  'admin.ai.model.fastDesc': 'Błyskawiczne odpowiedzi do szybkich kontroli nisz, burzy mózgów i wstępnych ocen. Idealne, gdy liczy się szybkość.',
  'admin.ai.model.fast': 'SZYBKI',
  'admin.ai.model.fastestResponses': 'Najszybsze odpowiedzi',
  'admin.ai.model.thinkingDesc': 'Głęboka analiza z zaawansowanym myśleniem logicznym. Do złożonych analiz rynkowych, krytycznych ocen i planowania strategicznego.',
  'admin.ai.model.deepestAnalysis': 'Najgłębsza analiza',
  'admin.ai.model.logicalThinking': 'Myślenie logiczne',
  'admin.ai.model.strategy': 'Strategia',

  // --- Nazwy i opisy presetów AI ---
  'admin.ai.preset.strict.name': 'Surowe analizy',
  'admin.ai.preset.strict.desc': 'Krytyczne, oparte na faktach, bez lukrowania. Bezwzględnie ujawnia słabości.',
  'admin.ai.preset.extreme.name': 'EKSTREMALNE analizy',
  'admin.ai.preset.extreme.desc': 'Maksymalna surowość, bezwzględna krytyka, skupienie na najgorszym przypadku. Tylko do twardych kontroli rzeczywistości.',
  'admin.ai.preset.professional.name': 'Profesjonalne',
  'admin.ai.preset.professional.desc': 'Obiektywne, ustrukturyzowane, zrównoważone. Jak doświadczony konsultant biznesowy.',
  'admin.ai.preset.realistic.name': 'Realistyczne',
  'admin.ai.preset.realistic.desc': 'Uczciwe i praktyczne. Skupienie na możliwej do wdrożenia realizacji i rzeczywistych danych rynkowych.',
  'admin.ai.preset.creative.name': 'Kreatywne i motywujące',
  'admin.ai.preset.creative.desc': 'Inspirujące, bogate w pomysły, pozytywne. Znajduje możliwości i niekonwencjonalne ścieżki.',
  'admin.ai.preset.balanced.name': 'Zrównoważone',
  'admin.ai.preset.balanced.desc': 'Dobra mieszanka krytyki i motywacji. Domyślny tryb.',
  'admin.ai.preset.investor.name': 'Perspektywa inwestora',
  'admin.ai.preset.investor.desc': 'Jak venture capitalist. Skupienie na skalowaniu, ROI i strategii wyjścia.',
  'admin.ai.preset.startup-coach.name': 'Trener startupów',
  'admin.ai.preset.startup-coach.desc': 'Praktyczny mentor dla założycieli. Skupienie na szybkim wdrożeniu i MVP.',
  'admin.ai.preset.market-researcher.name': 'Badacz rynku',
  'admin.ai.preset.market-researcher.desc': 'Oparte na danych i analityczne. Głęboka analiza rynku i konkurencji.',
  'admin.ai.preset.risk-analyst.name': 'Analityk ryzyka',
  'admin.ai.preset.risk-analyst.desc': 'Skupienie na ryzyku i najgorszych scenariuszach. Do realistycznego planowania.',

  // --- Obszary skupienia ---
  'admin.ai.focus.marktanalyse': 'Analiza rynku',
  'admin.ai.focus.wettbewerb': 'Konkurencja',
  'admin.ai.focus.monetarisierung': 'Monetyzacja',
  'admin.ai.focus.risiken': 'Ryzyka',
  'admin.ai.focus.finanzen': 'Finanse',
  'admin.ai.focus.skalierung': 'Skalowanie',
  'admin.ai.focus.innovation': 'Innowacja',
  'admin.ai.focus.trends': 'Trendy',
  'admin.ai.focus.differenzierung': 'Różnicowanie',
  'admin.ai.focus.umsetzung': 'Wdrożenie',
  'admin.ai.focus.zielgruppe': 'Grupa docelowa',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Opcje tonu ---
  'admin.ai.tone.direkt': 'Bezpośredni i ostry',
  'admin.ai.tone.professionell': 'Profesjonalny i obiektywny',
  'admin.ai.tone.ehrlich': 'Uczciwy i praktyczny',
  'admin.ai.tone.motivierend': 'Motywujący i pozytywny',
  'admin.ai.tone.freundlich': 'Przyjazny i wspierający',
  'admin.ai.tone.akademisch': 'Akademicki i analityczny',

  // --- Przykładowe pytania ---
  'admin.ai.question.niche': 'Którą dochodową niszę polecasz?',
  'admin.ai.question.evaluate': 'Oceń mój pomysł: Aplikacja dla właścicieli psów',
  'admin.ai.question.trends': 'Które trendy mają obecnie potencjał?',
  'admin.ai.question.sharpen': 'Jak mogę wyostrzyć moją niszę?',

  'admin.ai.rec.bestCombination.title': '🏆 Najlepsza kombinacja (2 presety)',
  'admin.ai.rec.bestCombination.desc': 'Krytyczne, ale konstruktywne, z konkretnymi krokami działania',
  'admin.ai.rec.bestCombination.useCase': 'Zalecane do większości analiz',

  'admin.ai.rec.balancedThree.title': '⚖️ Zrównoważone (3 presety)',
  'admin.ai.rec.balancedThree.desc': 'Profesjonalne, realistyczne i przyjazne dla inwestorów',
  'admin.ai.rec.balancedThree.useCase': 'Do kompleksowych analiz biznesowych',

  'admin.ai.rec.creativeDriven.title': '💡 Kreatywne i motywujące (2 presety)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirujące z praktycznymi wskazówkami wdrożeniowymi',
  'admin.ai.rec.creativeDriven.useCase': 'Do generowania pomysłów i burzy mózgów',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Otwórz menu',
  'header.home': 'Strona główna',
  'header.notifications': 'Powiadomienia',
  'header.settings': 'Ustawienia',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Zwiń panel boczny',
  'sidebar.expand': 'Rozwiń panel boczny',
  'sidebar.close': 'Zamknij menu',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Powrót do witryny',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Witaj ponownie',
  'overview.greetingSub': 'Oto co dzieje się na twoim biurku werdyktów.',
  'overview.heroCta': 'Nowy werdykt',
  'overview.currentPlan': 'Aktualny plan',
  'overview.creditsLabel': 'kredytów',
  'overview.usedThisCycle': 'Użyte w tym cyklu',
  'overview.resetsOn': 'Reset',
  'overview.unlimitedTitle': 'Bez limitu',
  'overview.builderPerk': 'Masz pełny dostęp Builder — bez limitów.',
  'overview.runOne': 'Uruchom werdykt',
  'overview.lastVerdicts': 'Twoich 5 ostatnich werdyktów',
  'overview.noActivity': 'Brak werdyktów — rozpocznij pierwszą analizę',
  'overview.tipTitle': 'Wskazówka',
  'overview.tipBody': 'Sprawdź pomysł w dwóch językach — jeśli werdykt łagodnieje, twoje założenia są lokalne, nie uniwersalne.',
  'onboard.skip': "Pomiń",
  'onboard.cta.next': "Dalej",
  'onboard.cta.start': "Zaczynamy",
  'onboard.s1.title': "Witaj w IdeaVerdict",
  'onboard.s1.body': "Werdykt AI o Twoim pomyśle biznesowym — zanim zaczniesz budować.",
  'onboard.s2.title': "Brutalnie szczere werdykty",
  'onboard.s2.body': "Bez hype'u, bez pochlebstw. Prawdziwe dane rynkowe, prawdziwa konkurencja, prawdziwe ryzyko.",
  'onboard.s3.title': "Raporty Buildera w PDF",
  'onboard.s3.body': "Generuj raporty 25-75 stron z pełną architekturą, finansami i strategią wejścia na rynek.",
  'onboard.s4.title': "Gotowe, gdy Ty jesteś",
  'onboard.s4.body': "Zarejestruj się i otrzymaj pierwszy werdykt w mniej niż minutę.",
  'builderReport.title': "Tworzenie Twojego Builder Report",
  'builderReport.subtitle': "Pełna analiza + briefing dla dewelopera — pobiera się jako PDF, gdy gotowe.",
  'builderReport.idea': "Twój pomysł",
  'builderReport.ideaPlaceholder': "Opisz swój pomysł biznesowy (lub zostaw puste, by użyć ostatnio omawianego)…",
  'builderReport.cta': "Generuj raport",
  'builderReport.credits': "kredytów",
  'builderReport.deductedNow': "Pobierane po sukcesie",
  'builderReport.dontClose': "Nie zamykaj tego okna — generowanie może zająć 30-90 sekund.",
  'builderReport.done': "PDF pobrany — sprawdź folder pobrań.",
  'builderReport.failed': "Generowanie nie powiodło się",
  'builderReport.close': "Zamknij",
  'builderReport.cancel': "Anuluj",
  'builderReport.running': "Generowanie…",
  'builderReport.retry': "Spróbuj ponownie",
  'builderReport.unknownError': "Generowanie nie powiodło się. Kredyty powinny zostać zwrócone.",
  'builderReport.signInRequired': "Musisz być zalogowany, aby wygenerować raport.",
  'builderReport.ideaRequired': "Opisz swój pomysł, żeby AI miało co analizować.",
  'builderReport.fromChat': "Z bieżącej rozmowy",
  'builderReport.noIdeaDetected': "Używamy pomysłu, który omawialiśmy.",
  'builderReport.contextHint': "AI użyje wszystkiego z tego czatu — żaden nowy pomysł nie zostanie wymyślony.",
  'builderReport.step.core': "Generowanie analizy podstawowej",
  'builderReport.step.market': "Dodawanie rozszerzonej analizy rynku",
  'builderReport.step.tech': "Dodawanie architektury technicznej",
  'builderReport.step.financials': "Dodawanie modeli finansowych",
  'builderReport.step.compet': "Dodawanie wywiadu konkurencyjnego",
  'builderReport.step.gtm': "Dodawanie strategii wejścia na rynek",
  'builderReport.step.deepdive': "Dodawanie pogłębionej analizy branży",
  'builderReport.step.pdf': "Kompilacja PDF…",
  'briefing.title': "Tworzenie Twojego Developer Briefing",
  'briefing.subtitle': "11-sekcyjny briefing techniczny — pobiera się jako PDF, gdy gotowe.",
  'briefing.ideaPlaceholder': "Opisz swój pomysł biznesowy (lub zostaw puste, by użyć ostatnio omawianego)…",
  'briefing.cta': "Generuj briefing",
  'briefing.step.core': "Generowanie briefingu dewelopera",
  'briefing.step.pdf': "Kompilacja PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Więcej kredytów + raporty 50-stronicowe",
  'pricing.gold.credits': "12 500 kredytów miesięcznie",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Najwyższy poziom + raporty 75-stronicowe",
  'pricing.platinum.credits': "15 000 kredytów miesięcznie",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "pl" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Zostało tylko {{count}} kredytów!",
  'trial.upgradeNow': "Ulepsz teraz",
  'trial.upgradeNowArrow': "Ulepsz teraz →",
  'trial.creditsExhausted': "Kredyty wyczerpane",
  'trial.upgradeForUnlimited': "Ulepsz, by korzystać bez limitu",
  'trial.noCreditsPlaceholder': "Brak kredytów…",
  'hero.badgeHonest': "Uczciwe, bezstronne AI",
  'hero.badge60sec': "Werdykt w 60 sekund",
  'hero.badge20Lang': "Ponad 20 języków",
  'hero.widget.label': "Werdykt pomysłu",
  'hero.widget.passed': "ZALICZONE",
  'hero.widget.demoIdea': "AI-korepetytor dla studentów medycyny",
  'hero.widget.market': "Rynek",
  'hero.widget.demand': "Popyt",
  'hero.widget.competition': "Konkurencja",
  'hero.widget.verdictReady': "Werdykt gotowy · 47 sek",
  'hero.widget.riskFlagged': "Oznaczone ryzyko",
  'hero.widget.crowdedMarket': "Zatłoczony rynek · 4 graczy",
  'hero.widget.suggestedPivot': "Sugerowany pivot",
  'hero.widget.nicheBySpecialty': "Nisza według specjalizacji",
  'hero.widget.feasibilityGain': "+38% wykonalności",
  'hero.widget.analysisDone': "Analiza ukończona",
  'hero.widget.metrics56': "5 z 6 metryk",
  'hero.stats.verdictSpeed': "Szybkość werdyktu",
  'cta.badge': "Werdykt w 60 sekund",
  'cta.subtitleEnd': "bez zgadywania.",
  'cta.signinPrompt': "Masz już konto? Zaloguj się",
  'cta.trustTrial': "7-dniowy darmowy okres próbny",
  'cta.trustNoCard': "Bez karty",
  'cta.trustCancel': "Anuluj kiedy chcesz",
  'footer.themeLabel': "Motyw:",
  'footer.lightMode': "Tryb jasny",
  'footer.darkMode': "Tryb ciemny",
  'footer.sectionProduct': "Produkt",
  'footer.sectionLegal': "Prawne",
  'nav.switchLight': "Przełącz na tryb jasny",
  'nav.switchDark': "Przełącz na tryb ciemny",
  'features.badge': "Dlaczego IdeaVerdict",
  'features.mainFeatureLabel': "Najważniejsze",
  'chatError.planRestriction': "Ta funkcja wymaga wyższego planu.",
  'chatError.creditDeduction': "Nie udało się przetworzyć płatności. Spróbuj ponownie.",
  'chatError.aiService': "Usługa AI jest chwilowo niedostępna. Twoje kredyty nie zostały pobrane. Spróbuj ponownie.",
  'chatError.parseError': "Otrzymano nieoczekiwany format odpowiedzi. Spróbuj ponownie.",
  'chatError.sessionExpired': "Twoja sesja wygasła. Zaloguj się ponownie.",
  'chatError.timeout': "Żądanie trwało zbyt długo. Spróbuj ponownie.",
  'chatError.generic': "Nie udało się uzyskać odpowiedzi. Spróbuj ponownie.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "pl" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Zostało tylko {{count}} kredytów!",
  'trial.outOfCredits': "Kredyty wyczerpane",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Zatłoczony rynek · 4 graczy",
  'hero.widget.nicheBySpec': "Nisza według specjalizacji",
  'hero.widget.feasibilityUp': "+38% wykonalności",
  'hero.widget.fiveOfSix': "5 z 6 metryk",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report 25 stron",
  'pricing.gold.report': "Builder Report 50 stron",
  'pricing.platinum.report': "Builder Report 75 stron",
  'auth.bestValue': "Najlepsza wartość",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "Nie udało nam się dokończyć Twojego raportu tym razem. Twoje kredyty nie zostały pobrane — spróbuj ponownie za chwilę.",
  'builderReport.persistHint': "Jeśli problem się powtarza, skontaktuj się z support@ideaverdict.ai.",
};
